import { normalizeEmotion } from "../../utils/emotion";
import { ANI_EMO_EYE_FRAMES } from "../../assets/ani_emo_eye_frames";
import { CONTENT_H, CONTENT_W } from "./chunk-0.jsx";
export function pickOledKind(emotion) {
  const e = normalizeEmotion(emotion);
  switch (e) {
    case 'loving':
      return {
        kind: 'hearts'
      };
    case 'sleepy':
      return {
        kind: 'dashes'
      };
    case 'angry':
      return {
        kind: 'slants',
        tilt: 18
      };
    case 'sad':
      return {
        kind: 'slants',
        tilt: -12
      };
    case 'surprised':
      return {
        kind: 'round'
      };
    case 'laughing':
      return {
        kind: 'squares'
      };
    case 'winking':
      return {
        kind: 'wink'
      };
    case 'confused':
      return {
        kind: 'slants',
        tilt: 6,
        gap: 18
      };
    case 'thinking':
      return {
        kind: 'slants',
        tilt: 0,
        gap: 10
      };
    case 'cool':
      return {
        kind: 'shades'
      };
    case 'embarrassed':
      return {
        kind: 'round',
        blush: true
      };
    case 'happy':
      return {
        kind: 'slants',
        tilt: -6
      };
    case 'relaxed':
      return {
        kind: 'slants',
        tilt: -2,
        gap: 18
      };
    case 'silly':
      return {
        kind: 'squares'
      };
    case 'confident':
      return {
        kind: 'slants',
        tilt: 12
      };
    case 'delicious':
      return {
        kind: 'squares',
        blush: true
      };
    case 'neutral':
    default:
      return {
        kind: 'slants',
        tilt: 0
      };
  }
}
export function roboMoodFromEmotion(emotion) {
  const e = normalizeEmotion(emotion);
  if (['happy', 'loving', 'cool', 'relaxed', 'confident', 'delicious', 'silly'].includes(e)) return 'happy';
  if (e === 'angry') return 'angry';
  if (['sleepy', 'sleep', 'tired', 'sad', 'crying'].includes(e)) return 'tired';
  return 'default';
}
export function shouldRoboConfusedAnim(emotion) {
  const e = normalizeEmotion(emotion);
  return ['confused', 'thinking', 'surprised', 'embarrassed'].includes(e);
}
export function shouldRoboLaughAnim(emotion) {
  const e = normalizeEmotion(emotion);
  return e === 'laughing';
}
export function shouldRoboWink(emotion) {
  const e = normalizeEmotion(emotion);
  return e === 'winking';
}

// Ani‑Emo‑Eye raw renderer
export
// Ani‑Emo‑Eye raw renderer
const ANI_W = 128;
export const ANI_H = 64;
export const ANI_PEYES = [[['eye4', 'eye4'], ['eye5', 'eye5'], ['eye6', 'eye6']],
// Happy
[['eye1', 'eye1'], ['eye2', 'eye2'], ['eye3', 'eye3']],
// Neutral
[['eye0', 'eye0'], ['eye0', 'eye0'], ['eye0', 'eye0']],
// Sleep
[['eye10d', 'eye10i'], ['eye11d', 'eye11i'], ['eye12d', 'eye12i']],
// Angry
[['eye7', 'eye7'], ['eye8', 'eye8'], ['eye9', 'eye9']],
// Upset
[['eye13d', 'eye13i'], ['eye14d', 'eye14i'], ['eye15d', 'eye15i']],
// Sad
[['eye16d', 'eye16i'], ['eye16d', 'eye16i'], ['eye16d', 'eye16i']] // Love
];
export function aniMoodIdFromEmotion(emotion) {
  const e = normalizeEmotion(emotion);
  switch (e) {
    case 'happy':
    case 'laughing':
      return 0;
    case 'sleepy':
      return 2;
    case 'angry':
      return 3;
    case 'sad':
      return 5;
    case 'loving':
      return 6;
    case 'confused':
    case 'thinking':
      return 4;
    default:
      return 1;
  }
}
export function getAniFrameBytes(name) {
  const arr = ANI_EMO_EYE_FRAMES?.[name];
  return Array.isArray(arr) ? arr : null;
}
export function drawBitmap(ctx, x0, y0, bytes, w, h, scale = 1) {
  const byteWidth = Math.ceil(w / 8);
  ctx.fillStyle = '#fff';
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const byteIndex = y * byteWidth + (x >> 3);
      const b = bytes[byteIndex] ?? 0;
      const mask = 0x80 >> (x & 7);
      if (b & mask) {
        ctx.fillRect(x0 + x * scale, y0 + y * scale, scale, scale);
      }
    }
  }
}

// esp32-eyes minimal renderer
export
// esp32-eyes minimal renderer
const ESP_OLED_W = 128;
export const ESP_OLED_H = 64;
export const ESP_OLED_EYE_SIZE = 40;
export const ESP_OLED_EYE_GAP = 4;
export const ESP_TFT_W = 240;
export const ESP_TFT_H = 135;
export function espCanvasProfile(variant) {
  const v = String(variant || '').toLowerCase();
  if (v === 'lcd') {
    const eyeSize = Math.round(CONTENT_H * (ESP_OLED_EYE_SIZE / ESP_OLED_H));
    const eyeGap = Math.max(1, Math.round(eyeSize * (ESP_OLED_EYE_GAP / ESP_OLED_EYE_SIZE)));
    return {
      w: CONTENT_W,
      h: CONTENT_H,
      eyeSize,
      eyeGap
    };
  }
  if (v === 'tft_espi') {
    const eyeSize = Math.round(ESP_TFT_H * (ESP_OLED_EYE_SIZE / ESP_OLED_H));
    const eyeGap = Math.max(1, Math.round(eyeSize * (ESP_OLED_EYE_GAP / ESP_OLED_EYE_SIZE)));
    return {
      w: ESP_TFT_W,
      h: ESP_TFT_H,
      eyeSize,
      eyeGap
    };
  }
  return {
    w: ESP_OLED_W,
    h: ESP_OLED_H,
    eyeSize: ESP_OLED_EYE_SIZE,
    eyeGap: ESP_OLED_EYE_GAP
  };
}
export function clearCanvas(ctx, w, h) {
  ctx.clearRect(0, 0, w, h);
}
export function espBufSet(buf, w, h, x, y, v) {
  if (x < 0 || y < 0 || x >= w || y >= h) return;
  buf[y * w + x] = v ? 1 : 0;
}
export function espBufHLine(buf, w, h, x, y, len, v) {
  if (len <= 0) return;
  const y0 = Math.round(y);
  if (y0 < 0 || y0 >= h) return;
  const start = Math.round(x);
  const end = start + Math.round(len);
  for (let xi = start; xi < end; xi++) espBufSet(buf, w, h, xi, y0, v);
}
export function espBufFillRect(buf, w, h, x0, y0, x1, y1, v) {
  const l = Math.min(x0, x1);
  const r = Math.max(x0, x1);
  const t = Math.min(y0, y1);
  const b = Math.max(y0, y1);
  const ww = Math.round(r - l);
  const hh = Math.round(b - t);
  if (ww <= 0 || hh <= 0) return;
  const sx = Math.round(l);
  const sy = Math.round(t);
  for (let yy = 0; yy < hh; yy++) {
    for (let xx = 0; xx < ww; xx++) espBufSet(buf, w, h, sx + xx, sy + yy, v);
  }
}
export function espBufFillRectTri(buf, w, h, x0, y0, x1, y1, v) {
  const dx = x1 - x0;
  if (!dx) return;
  const step = dx > 0 ? 1 : -1;
  for (let x = x0; x !== x1 + step; x += step) {
    const t = (x - x0) / dx;
    const yEdge = y0 + (y1 - y0) * t;
    const yStart = Math.round(Math.min(y0, yEdge));
    const yEnd = Math.round(Math.max(y0, yEdge));
    for (let yy = yStart; yy <= yEnd; yy++) espBufSet(buf, w, h, Math.round(x), yy, v);
  }
}
